import React from "react";
import FilterTableCampaignVoice from "./FilterTableCampaignVoice";
import "../../../../src/assets/css/material-dashboard_1.css";

export default function VoiceCampaignData() {
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <section className="cmp">
          <div className="container-fluid">
            <div className="container-fluid_1">
              <section className="marquee_8 modl">
                <div className="d-flex justify-content-between">
                  <marquee>
                    Dear User !! There is an upgradation activity scheduled on
                    30th January 2023 00:00Hrs to 31st January 2023 03:00 Hrs.
                    All the operations will remain suspended during the given
                    time.
                  </marquee>
                </div>
              </section>
              <section className="sms_dlvry py-2 mt-3">
                <FilterTableCampaignVoice />
              </section>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
